import React, { Component } from 'react';

class Popover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
      wrapperWidth: 0
    };

    this.updateWrapperWidth = this.updateWrapperWidth.bind(this);
    this.handleMouseover = this.handleMouseover.bind(this);
    this.handleMouseleave = this.handleMouseleave.bind(this);
  }

  componentDidMount() {
    this.container.addEventListener('mouseover', this.handleMouseover);
    this.container.addEventListener('mouseleave', this.handleMouseleave);

    this.updateWrapperWidth();
  }

  componentDidUpdate(prevProps, prevState) {
    const { text } = this.props;
    const textHasChanged = text !== prevProps.text;
    if (textHasChanged) {
      this.updateWrapperWidth();
    }
  }

  updateWrapperWidth() {
    const wrapperWidth = this.wrapper.clientWidth;
    this.setState({ wrapperWidth });
  }

  handleMouseover() {
    this.setState({ hover: true });
  }

  handleMouseleave() {
    this.setState({ hover: false });
  }

  render() {
    const { text, children } = this.props;
    const { hover, wrapperWidth } = this.state;

    const left = `calc(50% - ${wrapperWidth / 2}px)`;

    return (
      <div className="popover" ref={node => this.container = node}>
        {children}
        <div
          className="popover__content"
          style={{ left }}
          ref={node => this.wrapper = node}
        >
          <div className="popover__indicator" />
          <div className="popover__text">{text}</div>
        </div>
      </div>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/js/Ui/Popover/Popover.jsx